import * as React from "react";
import type { SVGProps } from "react";
const SvgHome = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeWidth={1.5}
      d="M6 20.25h12A2.25 2.25 0 0 0 20.25 18v-7.148L12 3.975l-8.25 6.877V21"
    />
  </svg>
);
export default SvgHome;
